import { connect } from "react-redux";

import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { FormActionHandler } from "../../Internals/FormActionHandlers/FormActionHandler";
import {
    FormActionHandlerExecutionInjectableProps,
    withFormActionHandlerExecution,
} from "../../Internals/FormActionHandlers/WithFormActionHandlerExecution";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";

import { Button } from "./Button";

export interface ButtonContainerProps extends FormActionHandlerExecutionInjectableProps {
    bindingPath?: AbsoluteModelPath;
    value?: string;
    viewModelSelect: ViewModelSelect;
    onClick?: FormActionHandler;
}

const mapStateToProps = (state: FullFormState, ownProps: ButtonContainerProps) => {
    const { bindingPath, value = "", viewModelSelect } = ownProps;

    if (bindingPath == undefined || !bindingPath.isResolved()) {
        return { value: value };
    }
    const controlModel = viewModelSelect.controlModel(state, bindingPath);

    return {
        value: controlModel.value ?? value,
        error: controlModel.error,
        warning: controlModel.warning,
    };
};

const mapDispatchToProps = (_: CandyDispatch, ownProps: ButtonContainerProps) => ({
    onClick: async () => {
        if (ownProps.onClick != undefined) {
            await ownProps.executeFormActionHandler(ownProps.onClick);
        }
    },
});

export const ButtonContainer = withResolvePaths(
    withFocusManagement(
        withFormActionHandlerExecution(
            withControlDebugInfo(
                withViewModelSelect(
                    connect(mapStateToProps, mapDispatchToProps)(withTestPageObjectRegistration(Button))
                )
            )
        )
    )
);
